import { changelogIcon } from "@/lib/changelog-icons";
import type { ChangelogRelease } from "@/lib/changelog";

/** Icon callouts at the top of a release (shared by the page + the modal). */
export function ReleaseHighlights({
  highlights,
}: {
  highlights: NonNullable<ChangelogRelease["highlights"]>;
}) {
  return (
    <ul className="space-y-2">
      {highlights.map((h, i) => {
        const Icon = changelogIcon(h.icon);
        return (
          <li key={i} className="flex items-start gap-2.5">
            <span className="mt-0.5 grid size-7 shrink-0 place-items-center rounded-md bg-primary/10 text-primary">
              <Icon className="size-4" />
            </span>
            <span className="text-sm leading-relaxed">{h.text}</span>
          </li>
        );
      })}
    </ul>
  );
}

/** Plain bullet list of changes (shared by the page + the modal). */
export function ReleaseChanges({ changes }: { changes: string[] }) {
  return (
    <ul className="space-y-1.5">
      {changes.map((c, i) => (
        <li key={i} className="flex gap-2 text-sm leading-relaxed text-muted-foreground">
          <span className="mt-2 size-1 shrink-0 rounded-full bg-muted-foreground/60" />
          <span>{c}</span>
        </li>
      ))}
    </ul>
  );
}
